import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';

const selectAI = (state: RootState) => state.ai;
const selectIsAIAutoMode = createSelector(selectAI, (ai) => ai.isAIAutoMode);
const selectIsAIEscalation = createSelector(
  selectAI,
  (ai) => ai.isAIEscalation
);
const selectAIStatus = createSelector(selectAI, (ai) => ai.aiStatus);

const selectAIEscalationReason = createSelector(
  selectAI,
  (ai) => ai.aiEscalationReason
);
const selectIsAIEscalatedOnCarEnter = createSelector(
  selectAI,
  (ai) => ai.isAIEscalatedOnCarEnter
);
const selectRequiresTakeover = createSelector(
  selectAI,
  (ai) => ai.requiresTakeover
);

export {
  selectAIStatus,
  selectIsAIAutoMode,
  selectIsAIEscalation,
  selectAIEscalationReason,
  selectIsAIEscalatedOnCarEnter,
  selectRequiresTakeover,
};
